export default __webpack_public_path__ + "media/images/to-google-store-100-afb88ff97630f4a84a6424e5750936df.png";